var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _line, _line2, _line3, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfinishedChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 150,
    viewBox: "0 0 176 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 75C150 116.421 116.421 150 75 150C33.5786 150 0 116.421 0 75C0 33.5786 33.5786 0 75 0C116.421 0 150 33.5786 150 75Z",
    fill: "#EBF7F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.572 131.815H47.032C44.5717 131.815 42.6035 129.84 42.6035 127.371V45.6473C42.6035 43.1783 44.5717 41.2031 47.032 41.2031H171.572C174.032 41.2031 176 43.1783 176 45.6473V127.42C176 129.84 174.032 131.815 171.572 131.815Z",
    fill: "#D0ECF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176 122.679H42.6036V41.7082C42.6036 39.1506 44.5718 37.1046 47.0321 37.1046H171.572C174.032 37.1046 176 39.1506 176 41.7082V122.679Z",
    fill: "#117BC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.321 38.3635H47.5503C45.7254 38.3635 44.2461 39.8438 44.2461 41.6697V121.368H174.625V41.6697C174.625 39.8437 173.146 38.3635 171.321 38.3635Z",
    fill: "#EBF7F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.334 131.815H94.3187V148.11H124.334V131.815Z",
    fill: "#D0ECF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.84 147.884H83.7636C83.1796 147.884 82.7062 148.358 82.7062 148.942C82.7062 149.526 83.1796 150 83.7636 150H134.84C135.424 150 135.898 149.526 135.898 148.942C135.898 148.358 135.424 147.884 134.84 147.884Z",
    fill: "#D0ECF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.223 129.562C110.59 129.562 111.699 128.453 111.699 127.084C111.699 125.716 110.59 124.607 109.223 124.607C107.856 124.607 106.748 125.716 106.748 127.084C106.748 128.453 107.856 129.562 109.223 129.562Z",
    fill: "#A0DDE4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.334 138.777L94.3187 143.221V131.815H124.334V138.777Z",
    fill: "#A0DDE4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2275 48.9564C55.2275 47.4348 56.4603 46.2013 57.981 46.2013H163.362C164.883 46.2013 166.116 47.4348 166.116 48.9564V112.273C166.116 113.794 164.883 115.028 163.362 115.028H57.981C56.4603 115.028 55.2275 113.794 55.2275 112.273V48.9564Z",
    fill: "#D5E7E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1045 47.6333C54.1045 46.1117 55.3373 44.8782 56.858 44.8782H162.239C163.76 44.8782 164.993 46.1117 164.993 47.6333V110.95C164.993 112.471 163.76 113.705 162.239 113.705H56.858C55.3373 113.705 54.1045 112.471 54.1045 110.95V47.6333Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1045 47.6333C54.1045 46.1117 55.3373 44.8782 56.858 44.8782H162.239C163.76 44.8782 164.993 46.1117 164.993 47.6333V50.9338H54.1045V47.6333Z",
    fill: "#04B7EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M160.904 47.9065C160.904 48.5147 160.411 49.0077 159.803 49.0077C159.196 49.0077 158.703 48.5147 158.703 47.9065C158.703 47.2983 159.196 46.8053 159.803 46.8053C160.411 46.8053 160.904 47.2983 160.904 47.9065Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.778 47.9065C156.778 48.5147 156.285 49.0077 155.677 49.0077C155.07 49.0077 154.577 48.5147 154.577 47.9065C154.577 47.2983 155.07 46.8053 155.677 46.8053C156.285 46.8053 156.778 47.2983 156.778 47.9065Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M152.652 47.9065C152.652 48.5147 152.159 49.0077 151.551 49.0077C150.944 49.0077 150.451 48.5147 150.451 47.9065C150.451 47.2983 150.944 46.8053 151.551 46.8053C152.159 46.8053 152.652 47.2983 152.652 47.9065Z",
    fill: "#ED509B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.3884 98.445C86.3931 98.445 87.2076 97.6288 87.2076 96.6218C87.2076 95.6149 86.3931 94.7986 85.3884 94.7986C84.3837 94.7986 83.5692 95.6149 83.5692 96.6218C83.5692 97.6288 84.3837 98.445 85.3884 98.445Z",
    fill: "#0D0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5895 98.4451C72.5941 98.4451 73.4086 97.6288 73.4086 96.6219C73.4086 95.615 72.5941 94.7987 71.5895 94.7987C70.5848 94.7987 69.7703 95.615 69.7703 96.6219C69.7703 97.6288 70.5848 98.4451 71.5895 98.4451Z",
    fill: "#0D0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4482 101.536H86.1427V104.07H89.4482V101.536Z",
    fill: "#01AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1427 101.536H67.1968C66.9971 101.536 66.8197 101.38 66.7975 101.18V104.07H86.1427V101.536Z",
    fill: "#117BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7975 101.135V94.9987H63.98V101.269C63.98 102.825 65.2224 104.07 66.7753 104.07H66.7975V101.18C66.7975 101.158 66.7975 101.158 66.7975 101.135Z",
    fill: "#01AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.98 91.9527V94.9987H66.7975V92.0861C66.7975 91.886 66.9528 91.7081 67.1524 91.6859H64.0022C63.98 91.7748 63.98 91.8637 63.98 91.9527Z",
    fill: "#0092C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6422 89.1512C65.2445 89.2179 64.1131 90.3074 64.0022 91.6859H67.1524C67.1746 91.6859 67.1746 91.6859 67.1968 91.6859H86.897V89.1512H66.6422Z",
    fill: "#0ED6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8748 89.1512V91.6859H89.8005C90.0015 91.6859 90.1802 91.8415 90.2025 92.0416V89.1512H86.8748Z",
    fill: "#0CC4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3578 89.1512H90.2025V92.0416C90.2025 92.0638 90.2025 92.0638 90.2025 92.0861V100.824H93.02V91.9527C92.9978 90.4408 91.822 89.2179 90.3578 89.1512Z",
    fill: "#13E0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1118 85.5369V88.6389H79.1545V85.4925C79.8422 85.2701 80.3524 84.6698 80.3524 83.9361C80.3524 83.0245 79.5538 82.2908 78.5555 82.2908C77.5793 82.2908 76.7585 83.0245 76.7585 83.9361C76.7807 84.7143 77.3575 85.3591 78.1118 85.5369Z",
    fill: "#01AAE0"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9663 67.2933C94.9663 65.0841 96.7572 63.2933 98.9663 63.2933H149.334C151.543 63.2933 153.334 65.0841 153.334 67.2933V78.2908C153.334 80.4999 151.543 82.2908 149.334 82.2908H94.9663V67.2933Z",
    fill: "#04B7EF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100.9,
    y1: 68.2683,
    x2: 118.1,
    y2: 68.2683,
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100.9,
    y1: 72.2683,
    x2: 118.1,
    y2: 72.2683,
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100.9,
    y1: 76.2683,
    x2: 111.725,
    y2: 76.2683,
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M124.75 62.5433H124V63.2933V82.2908V83.0408H124.75H149.334C151.957 83.0408 154.084 80.9141 154.084 78.2908V67.2933C154.084 64.6699 151.957 62.5433 149.334 62.5433H124.75Z",
    fill: "#F3F2F2",
    stroke: "white",
    strokeWidth: 1.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.16 72.8033C138.16 72.6633 138.203 72.5466 138.29 72.4533C138.383 72.3599 138.497 72.3133 138.63 72.3133C139.077 72.2999 139.44 72.1766 139.72 71.9433C140.007 71.7033 140.15 71.3633 140.15 70.9233C140.15 70.5433 140.02 70.2299 139.76 69.9833C139.5 69.7299 139.18 69.6033 138.8 69.6033C138.587 69.6033 138.38 69.6499 138.18 69.7433C137.987 69.8299 137.817 69.9499 137.67 70.1033C137.537 70.2233 137.403 70.2833 137.27 70.2833C137.177 70.2833 137.09 70.2533 137.01 70.1933C136.863 70.0866 136.79 69.9633 136.79 69.8233C136.79 69.7033 136.84 69.5933 136.94 69.4933C137.167 69.2333 137.44 69.0299 137.76 68.8833C138.087 68.7366 138.433 68.6633 138.8 68.6633C139.227 68.6633 139.613 68.7599 139.96 68.9533C140.313 69.1466 140.593 69.4166 140.8 69.7633C141.007 70.1033 141.11 70.4899 141.11 70.9233C141.11 71.3233 141.02 71.6799 140.84 71.9933C140.667 72.2999 140.427 72.5499 140.12 72.7433C139.813 72.9299 139.467 73.0433 139.08 73.0833C139.073 73.0833 139.07 73.0866 139.07 73.0933C139.077 73.0933 139.087 73.0899 139.1 73.0833V73.7433C139.1 73.8766 139.053 73.9899 138.96 74.0833C138.873 74.1766 138.763 74.2233 138.63 74.2233C138.49 74.2233 138.373 74.1766 138.28 74.0833C138.193 73.9899 138.153 73.8766 138.16 73.7433V72.8033ZM138.6 76.0433C138.44 76.0433 138.317 75.9999 138.23 75.9133C138.143 75.8199 138.1 75.6933 138.1 75.5333V75.3433C138.1 75.1833 138.143 75.0599 138.23 74.9733C138.317 74.8799 138.44 74.8333 138.6 74.8333H138.7C138.86 74.8333 138.983 74.8799 139.07 74.9733C139.157 75.0599 139.2 75.1833 139.2 75.3433V75.5333C139.2 75.6933 139.157 75.8199 139.07 75.9133C138.983 75.9999 138.86 76.0433 138.7 76.0433H138.6Z",
    fill: "#3F3F3F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.04,
    height: 21.7795,
    fill: "white",
    transform: "translate(63.98 82.2908)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfinishedChat);
export default __webpack_public_path__ + "static/media/UnfinishedChat.bb6352660ca87ccc5d528b4b399c02e2.svg";
export { ForwardRef as ReactComponent };